/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';
import allProjectsData from './ProjectsData';
import { setAllProjectsData } from '../../redux/actions/actionCreate';
import './Projects.scss';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('ALL');
  // const [filterWork, setFilterWork] = useState([]);
  // const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  const dispatch = useDispatch();

  const projects = useSelector((state) => state.projects);

  const projectsT = 'pROJECT sECTION';

  useEffect(() => {
    dispatch(setAllProjectsData(allProjectsData));
  }, []);

  useEffect(() => {

  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    // setAnimateCard([{ y: 100, opacity: 0 }]);

    // setTimeout(() => {
    //   // setAnimateCard([{ y: 0, opacity: 1 }]);

    //   if (item === 'ALL') {
    //     setFilterWork(works);
    //   } else {
    //     setFilterWork(projects.filter((work) => work.tags.includes(item)));
    //   }
    // }, 500);
  };

  return (
    <motion.div id="projects" className="app__projects">
      <h1 className="app__projects-title">{projectsT}</h1>
      <div className="app__projects-filter">
        {['FRONTEND', 'FULL-STACK', 'ALL'].map((item) => (
          <div
            className={`app__projects-filter-item ${
              activeFilter === item ? 'item-active' : ''
            }`}
            key={item}
            onClick={() => handleWorkFilter(item)}
            role="button"
            tabIndex={0}
          >
            {item}
          </div>
        ))}
      </div>

      <div className="app__projects-portfolio">
        <motion.div className="app__projects-portfolio-items">
          {projects.map((sp) => (
            <div key={sp.id} className="app__projects-portfolio-space">
              <div>
                <img src={sp.image} alt={sp.name} />
                <motion.div
                  className="space-links"
                  whileInView={{ opacity: [0, 1], scale: [0, 1] }}
                  transition={{
                    duration: 0.45,
                    ease: 'easeInOut',
                    staggerChildren: 0.5,
                  }}
                >
                  <a href={sp.liveLink} target="_blank" rel="noreferrer">
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.7] }}
                      transition={{ duration: 0.85 }}
                      className="app_nav-links"
                    >
                      <AiFillEye />
                    </motion.div>
                  </a>
                  <a href={sp.liveLink} target="_blank" rel="noreferrer">
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.7] }}
                      transition={{ duration: 0.85 }}
                      className="app_nav-links"
                    >
                      <AiFillGithub />
                    </motion.div>
                  </a>
                </motion.div>
              </div>

              <div className="app__projects-content">
                <h3>{sp.title}</h3>
                <p>{sp.description}</p>
                <div className="app__projects-tags">
                  <p>
                    {sp.tags.react && `${sp.tags.react} | `}
                    {sp.tags.redux && `${sp.tags.redux} | `}
                    {sp.tags.js && `${sp.tags.js} | `}
                    {sp.tags.dom && `${sp.tags.dom} | `}
                    {sp.tags.rest && `${sp.tags.rest} | `}
                    {sp.tags.sanity && `${sp.tags.sanity} | `}
                    {sp.tags.sass && `${sp.tags.sass}`}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Projects;
